import "@/App.css";
import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";

// Landing loaded eagerly — it's the root LCP page most users land on
import LandingPage from "./pages/LandingPage";

// All other routes lazy-loaded to split JS bundle
const RegistroPage = lazy(() => import("./pages/RegistroPage"));
const RankingPage = lazy(() => import("./pages/RankingPage"));
const AgendaPage = lazy(() => import("./pages/AgendaPage"));
const AgendaMediosPage = lazy(() => import("./pages/AgendaMediosPage"));
const PerspectivasIndexPage = lazy(() => import("./pages/PerspectivasIndexPage"));
const PerspectivaArticlePage = lazy(() => import("./pages/PerspectivaArticlePage"));
const PatrociniosPage = lazy(() => import("./pages/PatrociniosPage"));
const AppPage = lazy(() => import("./pages/AppPage"));

const RouteFallback = () => (
  <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0B1E3D' }}>
    <div style={{ width: 44, height: 44, border: '3px solid rgba(255,255,255,0.15)', borderTopColor: '#FF6B35', borderRadius: '50%', animation: 'spin 0.9s linear infinite' }} />
    <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
  </div>
);

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Suspense fallback={<RouteFallback />}>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/registro" element={<Navigate to="/" replace />} />
              <Route path="/ComunidadIMEF" element={<Navigate to="/" replace />} />
              <Route path="/comunidadimef" element={<Navigate to="/" replace />} />
              <Route path="/ComunidadFintechMexico" element={<Navigate to="/" replace />} />
              <Route path="/comunidadfintechmexico" element={<Navigate to="/" replace />} />
              <Route path="/ComunidadALECCC" element={<Navigate to="/" replace />} />
              <Route path="/comunidadaleccc" element={<Navigate to="/" replace />} />
              <Route path="/ranking" element={<RankingPage />} />
              <Route path="/Ranking" element={<RankingPage />} />
              <Route path="/agenda" element={<AgendaPage />} />
              <Route path="/Agenda" element={<AgendaPage />} />
              <Route path="/agendamedios" element={<AgendaMediosPage />} />
              <Route path="/AgendaMedios" element={<AgendaMediosPage />} />
              <Route path="/perspectivas" element={<PerspectivasIndexPage />} />
              <Route path="/Perspectivas" element={<PerspectivasIndexPage />} />
              <Route path="/perspectivas/:slug" element={<PerspectivaArticlePage />} />
              <Route path="/patrocinios" element={<PatrociniosPage />} />
              <Route path="/Patrocinios" element={<PatrociniosPage />} />
              <Route path="/patrocinadores" element={<PatrociniosPage />} />
              <Route path="/app-asofom" element={<AppPage />} />
              <Route path="/App-Asofom" element={<AppPage />} />
              <Route path="/app" element={<AppPage />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
